// extracted by mini-css-extract-plugin
export default {"container":"confirmationLink_container__teDDL","tooltip":"confirmationLink_tooltip__A3NyE","body":"confirmationLink_body__l6FJl","buttons":"confirmationLink_buttons__UlgKZ"};